import { useEffect, useState } from 'react';
import { applyUpdate, onUpdateReady } from '../lib/pwa';

/**
 * "A newer Ìran is ready."
 *
 * Deliberately a prompt and not an automatic reload. Someone may be halfway
 * through recording a grandmother, or typing out what a letter says; throwing
 * that away to install an improvement would be its own small betrayal. The
 * banner waits, and the app keeps working on the old build until they say so.
 */
export function UpdateBanner() {
  const [ready, setReady] = useState(false);
  useEffect(() => onUpdateReady(setReady), []);
  if (!ready) return null;

  return (
    <div className="update-card" role="status">
      <span aria-hidden="true">✨</span>
      <div className="stack tight">
        <strong>A newer Ìran is ready</strong>
        <span className="muted small">Reload when it suits you — nothing you are in the middle of will be lost.</span>
      </div>
      <button className="btn small" onClick={applyUpdate}>
        Reload
      </button>
    </div>
  );
}
